import type { User } from "~/composables/api/account/useUser";

interface LoginBody {
  nid: string;
  password: string;
}

interface LoginResult {
  accessToken: string;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  accessTokenExpiresIn: number;
  expiresIn: number;
  account: User;
}

export const login = async (body: LoginBody): Promise<LoginResult> => {
  const { $authApi } = useNuxtApp();

  const res = await $authApi<{ data: LoginResult }>("/login", {
    method: "POST",
    body,
  });
  return res.data;
};
